import { Card } from './Card'

export const DeviceRestrictionMessage = () => {
  return (
    <div className="min-h-screen bg-muted flex items-center justify-center p-4">
      <div className="max-w-md w-full">
        <Card className="p-8 text-center">
          {/* Icon */}
          <div className="w-16 h-16 mx-auto mb-6 bg-red-100 rounded-full flex items-center justify-center">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 2L2 22H22L12 2Z" stroke="#EF4444" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <line x1="12" y1="9" x2="12" y2="13" stroke="#EF4444" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M12 17H12.01" stroke="#EF4444" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>

          {/* Title */}
          <h1 className="text-2xl font-bold text-foreground mb-4">
            Desktop Access Only
          </h1>

          {/* Message */}
          <p className="text-muted-foreground mb-6 leading-relaxed">
            This admin panel is designed for desktop use only. Please access from a desktop or laptop computer for the best experience.
          </p>

          {/* Brand */}
          <div className="border-t border-border pt-6">
            <h2 className="text-lg font-semibold text-foreground mb-2">
              Osprey Admin
            </h2>
            <p className="text-sm text-muted-foreground">
              Professional admin dashboard for managing your African fashion business
            </p>
          </div>

          {/* Instructions */}
          <div className="mt-6 p-4 bg-blue-50 rounded-lg">
            <h3 className="text-sm font-medium text-blue-900 mb-2">
              How to access:
            </h3>
            <ul className="text-sm text-blue-800 space-y-1 text-left">
              <li>• Use a desktop or laptop computer</li>
              <li>• Minimum screen width: 1024px</li>
              <li>• Supported browsers: Chrome, Firefox, Safari, Edge</li>
            </ul>
          </div>
        </Card>
      </div>
    </div>
  )
}